<!--
 * @Description: 客户参数配置
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @最后编辑: Betway
 * @最后修改时间: 2022-07-05 13:53:14
-->
<template>
  <div>
    <!-- !hasBtn('add-custom-param-config') -->
    <mrc_ess_table
      v-if="$route.name == 'customParamConfig'"
      :hideFooter="true"
      :headers="headers"
      pageName="customParamConfigAdd"
      :paginationOptions="options"
      @turnPage="getlist"
      :hideAddBtn="true"
      :isLoading="loading"
      itemKey="param_name"
      :slotKey="['param_value', 'param_name', 'param_description']"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <!-- <mrc_ess_advanceFilterAndSearchInput class="mt-4"
                                               v-model="systemSeniorQueryString"
                                               @success="getlist({ cpage: 1 })"
                                               :systemFieldMeta="systemFieldMeta">
          </mrc_ess_advanceFilterAndSearchInput> -->
        </v-row>
      </template>

      <template v-slot:btns>
        <v-btn
          fab
          v-if="hasBtn('add-custom-param-config')"
          class="ml-3 addBtns"
          depressed
          small
          color="primary"
          @click="handleAdd"
        >
          <v-icon class="material-icons">add</v-icon>
        </v-btn>
        <!-- v-if="hasBtn('add-custom-param-config')" -->
        <v-btn
          fab
          class="ml-3 addBtns"
          depressed
          small
          color="primary"
          @click="handleSave"
        >
          <v-icon class="material-icons">save</v-icon>
        </v-btn>
      </template>

      <template v-slot:item.param_name="{ item }">
        {{ INT(item.param_name) }}
      </template>

      <template v-slot:item.param_value="{ item }">
        <!-- 
      is_update
      prompt_name
 -->
        <span v-if="!item.prompt_name">
          {{ INT(item.param_value) }}
        </span>
        <div v-else>
          {{ INT(item.param_value) }}
          <!-- <div v-if="item.prompt_name.includes('《')">
            <mrc_ess_dictName v-model="item.param_value"
                              :rules="false"
                              multiple
                              view
                              :dict_name="item.prompt_name">
            </mrc_ess_dictName>
          </div>
          <div v-else>
            <mrc_ess_prompt v-model="item.param_value"
                            view
                            multiple
                            :obj="item.prompt_name">
            </mrc_ess_prompt>
          </div> -->
        </div>
      </template>

      <template v-slot:item.param_description="{ item }">
        {{ INT(item.param_description) }}
      </template>

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list
          :list="[
            {
              name: $t('label_View'),
              show: hasBtn('view-custom-param-config'),
              type: 'view',
            },
            {
              name: $t('label_Edit'),
              show: hasBtn('edit-custom-param-config'),
              type: 'edit',
            },
            {
              name: $t('label_delete'),
              show: Boolean(item.is_update)
                ? hasBtn('delete-custom-param-config')
                : false,
              type: 'del',
            },
          ]"
          @handleClick="handleClick($event, item)"
        >
          <!-- 'view-custom-param-config', -->
          <template v-slot:showAction>
            <!-- {{ Boolean(item.is_update)?'delete-custom-param-config':'sssss',}} -->
            <v-icon
              v-btnAuth="['edit-custom-param-config', 'delete-custom-param-config']"
            >
              mdi-dots-vertical
            </v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
    <mrc_ess_myDialog
      v-model="dialog"
      :title="$t('label_custom_param_config_dialog_title')"
      @success="customSave"
      @cancel="customClose"
    >
      <v-row>
        <v-col cols="12">
          <mrc_ess_multiText
            :label="$t('key') + '*'"
            backgroundColor="#f5f5f5"
            :readonly="!Boolean(list.is_update)"
            :error-messages="$errors('list', 'param_name', requiredRule)"
            :isNational="judegNational('param_name')"
            v-model="list.param_name"
          ></mrc_ess_multiText>
        </v-col>
        <v-col cols="12">
          <template v-if="!list.prompt_name">
            <!-- :error-messages="
                  $errors('list', 'param_value', requiredRule)
                  " -->

            <mrc_ess_input
              :label="$t('value')"
              textarea
              :rows="3"
              backgroundColor="#f5f5f5"
              v-model="list.param_value"
              :error-messages="
                $errors('list', 'param_value', [
                  { rule: 'isJSON', msg: $t('vertify_error_data_format_tips') },
                ])
              "
            ></mrc_ess_input>
            <!-- <mrc_ess_multiText
              :label="$t('value')"
              :isNational="judegNational('param_value')"
              v-model="list.param_value"
              :error-messages="
                $errors('list', 'param_value', [
                  { rule: 'isJSON', msg: $t('vertify_error_data_format_tips') },
                ])
              "
            >
            </mrc_ess_multiText> -->
          </template>
          <template v-else>
            <div v-if="list.prompt_name.includes('《')">
              <!-- :error-messages="$errors('list', 'param_value', requiredRule)" -->
              <mrc_ess_autoComplete
                :label="$t('value')"
                multiple
                itemText="dict_label"
                itemValue="dict_value"
                v-model="list.param_value"
                :dict_name="list.prompt_name.replace('《', '').replace('》', '')"
              ></mrc_ess_autoComplete>
            </div>
            <div v-else>
              <!-- :error-messages="$errors('list', 'param_value', requiredRule)" -->
              <mrc_ess_autoComplete
                :label="$t('value')"
                multiple
                v-model="list.param_value"
                :prompt_name="list.prompt_name"
              ></mrc_ess_autoComplete>
            </div>
          </template>
        </v-col>
        <v-col cols="12">
          <mrc_ess_multiText
            :label="$t('label_describe') + '*'"
            backgroundColor="#f5f5f5"
            :readonly="!Boolean(list.is_update)"
            :error-messages="$errors('list', 'param_description', requiredRule)"
            :isNational="judegNational('param_description')"
            v-model="list.param_description"
          ></mrc_ess_multiText>
        </v-col>
      </v-row>
    </mrc_ess_myDialog>
  </div>
</template>

<script>
import {
  custom_param_config_list,
  add_custom_param_config,
} from "@/service/api/customParamConfig.js";
import { getStaffListForFilter } from "@/service/api/autoComplete.js";
import { getBusinessList } from "@/service/api/prompt.js";
import { required, maxLength, between, email, url } from "vuelidate/lib/validators";
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      stepIndex: 1,
      dialog: false,
      disabled: true,
      options: {
        pagesize: 5, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
      list: {
        is_update: 1,
        param_name: "",
        param_value: "",
        param_description: "",
      },
      deleteList: [],
      currentIndex: -1,
      allList: [],
      correlation_uuid_obj: {},
    };
  },
  computed: {
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-custom-param-config"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-custom-param-config"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-custom-param-config"),
          type: "del",
        },
      ];
    },
    headers() {
      return [
        {
          text: this.$t("key"),
          align: "start",
          value: "param_name",
          sortable: false,
        },
        {
          text: this.$t("value"),
          value: "param_value",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_describe"),
          value: "param_description",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
          width: "100",
        },
      ];
    },
    company_uuid() {
      //当前选中公司
      return this.$store.state.currentCompany;
    },
    staff_correlation() {
      return {
        prompt_name: "staff_correlation",
        org_level_uuid: this.company_uuid,
      };
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "customParamConfig") {
        this.getlist();
      }
    },
  },
  async mounted() {
    this.loading = true;
    // const res = await getBusinessList(this.staff_correlation)
    // res.data.forEach(item => {
    //   this.correlation_uuid_obj[item.value_field] = item.view_fields
    // })
    // await this.getdropDownList()
    await this.getlist();
    this.loading = false;
  },
  beforeDestroy() {
    this.$ls.remove("staffList");
  },
  methods: {
    handleAdd() {
      this.dialog = true;
    },
    handleSave() {
      // console.log(this.desserts, this.deleteList);
      // return
      let deleteList = this.deleteList.map((item) => {
        return { ...item, "~type~": "del" };
      });
      add_custom_param_config({
        mrbase_sys_client_param: [...this.desserts, ...deleteList],
      }).then((res) => {
        if (res.code == 200) {
          this.getlist();
        }
      });
    },
    customSave() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      if (this.list.uuid) {
        this.desserts.splice(this.currentIndex, 1, this.$clone(this.list));
      } else {
        if (this.currentIndex != -1) {
          this.desserts.splice(this.currentIndex, 1, this.$clone(this.list));
        } else {
          this.desserts.push(this.$clone(this.list));
        }
      }
      this.customClose();
      // this.desserts
    },
    customClose() {
      this.list = {
        is_update: 1,
        param_name: "",
        param_value: "",
        param_description: "",
      };
      this.currentIndex = -1;
      this.$v.list.$reset();
      this.dialog = false;
    },
    async getdropDownList() {
      const res = await getStaffListForFilter({
        org_level_uuid: this.$store.state.currentCompany,
      });
      if (res.code == 200) {
        this.allList = res.data;
      }
    },
    async getlist(obj) {
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;
        this.options = { ...this.options, ...obj };
      }
      const res = await custom_param_config_list({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    godetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.show_name);
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "detailStaffRelationConfig",
      });
    },
    handleClick({ item }, obj, i) {
      this.currentIndex = this.desserts.findIndex((item) => {
        return (
          (item.uuid ? item.uuid == obj.uuid : false) || item.param_name == obj.param_name
        );
      });
      // console.log(this.currentIndex);
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.dialog = true;
          this.list = JSON.parse(JSON.stringify(obj));
          // console.log(this.currentIndex);
          // console.log(this.currentIndex);
          // console.log(obj, item, i);
          // this.$store.commit("set_subPage_name", obj.show_name)
          // this.$store.commit("set_iconstatus", false) //行内进图标显示
          // this.$store.commit("set_uuid", obj.uuid) //
          // this.$router.push({
          //   name: "detailStaffRelationConfig",
          // })
          break;
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            if (obj.uuid) {
              this.deleteList.push(obj);
            }
            this.desserts.splice(this.currentIndex, 1);
            // staff_relation_config_delete({ uuid: obj.uuid }).then((res) => {
            //   if (res.code === "200") {
            //     this.$Message({
            //       text: this.$t("message_The_deletion_was_successful"),
            //     })
            //     if (this.desserts.length == 1) this.options.cpage--
            //     this.getlist()
            //   }
            // })
          });
          break;
      }
    },
    success() {},
    cancel() {},
  },
  validations: {
    list: {
      param_name: {
        required,
      },
      param_value: {
        // required,
        isJSON(str) {
          str = str.trim();
          if (!str) return true;
          let start = str.substring(0, 2);
          let end = str.substring(str.length - 2, str.length);
          if (str[0] !== "{" && start !== '"{' && start !== "'{") {
            return true;
          }
          if (str.startsWith("{") && str.endsWith("}") && str.indexOf(":") == -1) {
            // 變量
            return true;
          }

          if ((start === '"{' && end === '}"') || (start === "'{" && end === "}'")) {
            str = str.substring(1, str.length - 1);
          }
          try {
            if (typeof str !== "string") {
              str = JSON.stringify(str);
            }
            var obj = JSON.parse(str);
            if (typeof obj == "object" && obj) {
              return true;
            } else {
              return false;
            }
          } catch (e) {
            return false;
          }
        },
      },
      param_description: {
        required,
      },
    },
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}

.addBtn {
  color: #fff;
  position: absolute;
  top: -65px;
  right: 10px;
}

.addBtns:hover {
  cursor: pointer !important;
}
</style>
